/**
 * Cookie utility functions
 */

/**
 * Create a cookie with specified name, value, and expiration in days
 * @param name - Cookie name
 * @param value - Cookie value
 * @param days - Number of days until expiration
 */
export function createCookie(name: string, value: string, days: number): void {
  if (typeof document === 'undefined') return;
  
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/`;
}

/**
 * Get a cookie value by name
 * @param name - Cookie name
 * @returns Cookie value or null if not found
 */
export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');
  
  for (const cookie of cookies) {
    let c = cookie;
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(nameEQ) === 0) {
      return decodeURIComponent(c.substring(nameEQ.length));
    }
  }
  return null;
}

/**
 * Delete a cookie by setting its expiration to the past
 * @param name - Cookie name
 */
export function deleteCookie(name: string): void {
  createCookie(name, '', -1);
}
